import IConfigsMo from "@services/configs/types/IConfigsMo";

const CONFIGS_DEVELOP: IConfigsMo = {
    iframeViewAddress: "http://localhost:8080", // This is fine as it refers to the frontend itself
    apiExpressAddress: "http://localhost:9080/api/v2", // Updated to use localhost
    v3API: "http://localhost:3000", // Updated to use localhost
    v1API: "http://localhost:4567/api", // Updated to use localhost
    featureFlagAddress: "http://localhost:3000", // Updated to use localhost
};

export default CONFIGS_DEVELOP;
